var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    {
      staticClass: "d-table-fixed pa-0",
      attrs: { "fill-height": "", fluid: "" },
    },
    [
      _c(
        "div",
        { staticClass: "d-table-header-group" },
        [
          _c(
            "v-card",
            { staticClass: "mb-2" },
            [
              _c(
                "v-row",
                { staticClass: "ma-0 py-1 pl-1" },
                [
                  _c(
                    "v-col",
                    { staticClass: "pa-0", attrs: { cols: "auto" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { icon: "", color: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.$router.push({
                                name: "dashboard",
                                params: { reload: _vm.search ? false : true },
                              })
                            },
                          },
                        },
                        [
                          _c("v-icon", { attrs: { size: "30" } }, [
                            _vm._v("mdi-arrow-left-circle"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "pa-0 pl-1",
                      staticStyle: { "padding-top": "0.1rem !important" },
                    },
                    [
                      _c(
                        "v-row",
                        { staticClass: "ma-0", attrs: { dense: "" } },
                        [
                          _c(
                            "v-col",
                            { staticClass: "d-flex align-center pa-0" },
                            [
                              _c(
                                "span",
                                { staticClass: "text-h5 font-weight-black" },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.houseBl.documentNbr) + " "
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "v-col",
                            { staticClass: "d-flex align-center pa-0" },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "text-h5 primary--text font-weight-black",
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.matchedPartyName) + " "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-card",
        { staticClass: "d-table-fixed fill-height", attrs: { width: "100%" } },
        [
          _c(
            "v-tabs",
            {
              staticClass: "d-table-header-group",
              attrs: {
                "background-color": "accent",
                height: "2rem",
                "fixed-tabs": "",
              },
              model: {
                value: _vm.tab,
                callback: function ($$v) {
                  _vm.tab = $$v
                },
                expression: "tab",
              },
            },
            [
              _c("v-tab", [_vm._v(_vm._s(_vm.$t("label.info")))]),
              _c("v-tab", [_vm._v(_vm._s(_vm.$t("label.documents")))]),
            ],
            1
          ),
          _c(
            "v-tabs-items",
            {
              staticStyle: { display: "table-row !important" },
              model: {
                value: _vm.tab,
                callback: function ($$v) {
                  _vm.tab = $$v
                },
                expression: "tab",
              },
            },
            [
              _c(
                "v-tab-item",
                { staticClass: "pa-2" },
                [
                  _vm.houseBl.id
                    ? _c("HouseBLMainTransportSea", {
                        attrs: { houseBl: _vm.houseBl },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "v-tab-item",
                { staticClass: "pa-2" },
                [_c("HouseBLDocuments", { attrs: { pratica: _vm.houseBl } })],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }